import React from 'react';
import PropTypes from 'prop-types';
import TextInputField from 'material-ui/TextField';
import { TableRowColumn } from 'material-ui/Table';

const TextInputTableCell = (props) => {
    const {
        inputWrapperStyle,
        name,
        onChangeInput,
        placeholder,
        style,
        value,
    } = props;

    return (
        <TableRowColumn style={ style }>
            <TextInputField
                id={ `${ value.id }` }
                style={ inputWrapperStyle }
                defaultValue={ value[name] }
                name={ name }
                onChange={ (e) => {
                    e.preventDefault();
                    return onChangeInput(e, value);
                } }
                placeholder={ placeholder }
            />

        </TableRowColumn>
    );
};

TextInputTableCell.propTypes = {
    inputWrapperStyle: PropTypes.object,
    name: PropTypes.string.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.object.isRequired,
};

export default TextInputTableCell;


// WEBPACK FOOTER //
// ./src/pages/products/configuration/TextInputTableCell.js